import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTestFilter = async () => {
  const res = await fetch(`${API_URL}/api/filter`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ filterscreen: "tests" }),
  });
  return res.json();
};

export const fetchTestsApi = async (queryParams, options = {}) => {
  const res = await fetch(`${API_URL}/api/tests?${queryParams.toString()}`, {
    method: "GET",
  });

  if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

  if (options.responseType === "blob") {
    return await res.blob();
  }
  return await res.json();
};

export const importTestsCSV = async (file) => {
  if (!file) throw new Error("No file provided");
  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${API_URL}/api/tests-import`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) throw new Error("CSV import failed");

  return res.json();
};
export const createTest = async (payload) => {
  const response = await fetch(`${API_URL}/api/tests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to create test");
  }

  return await response.json(); // Yeh response me test ka _id hoga
};
export const fetchTestById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/tests/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateGetFetchTest = async (testId) => {
  try {
    const res = await fetch(`${API_URL}/api/tests/${testId}`);
    const response = await res.json();
    console.log("Getting the data from update test api :", response);
    return { res, response };
  } catch (error) {
    console.error("Error fetching test:", error);
    throw error;
  }
};
export const updateTestsApi = async (testId, payload) => {
  try {
    console.log("getting data test id :", testId);
    console.log("getting data test  payload :", payload);
    const response = await fetch(`${API_URL}/api/tests/${testId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.message || "Failed to update test");
    }
    return response;
  } catch (error) {
    console.error("Error updating test", error);
    throw error;
  }
};
export const deleteTestById = async (testId) => {
  try {
    const res = await fetch(`${API_URL}/api/tests/${testId}`, {
      method: "DELETE",
    });
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Failed to delete test: ${errorText}`);
    }
    return res.json();
  } catch (error) {
    console.error("Error deleteTestById for test delete", error);
  }
};

export const sendAdminOtp = async (mobileNumber) => {
  const res = await axios.post(`${API_URL}/api/send-otp`, { mobileNumber });
  return res.data;
};

export const login = async (mobileNumber, otp) => {
  try {
    const res = await axios.post(`${API_URL}/api/login`, { mobileNumber, otp });
    return res.data;
  } catch (error) {
    console.error("Login error:", error.response?.data || error.message);
    throw error;
  }
};
export const refreshAccessToken = async (refreshToken) => {
  try {
    const res = await axios.post(`${API_URL}/api/refresh`, { refreshToken });
    return res.data.accessToken;
  } catch (error) {
    console.error(
      "Refresh token failed:",
      error.response?.data || error.message,
    );
  }
};
export const updateProfile = async (
  mobileNumber,
  accessToken,
  refreshToken,
) => {
  try {
    const res = await axios.put(
      `${API_URL}/api/profile`,
      { mobileNumber },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return res.data;
  } catch (error) {
    if (error.response?.status === 403) {
      try {
        // 🔁 refresh token se naya accessToken lao
        const newAccessToken = await refreshAccessToken(refreshToken);

        // ✅ component/localStorage me save karna component ka kaam hoga
        localStorage.setItem("accessToken", newAccessToken);

        // 🔁 retry with new token
        return updateProfile(mobileNumber, newAccessToken, refreshToken);
      } catch (refreshErr) {
        throw new Error("Session expired. Please login again.");
      }
    }

    console.error(
      "Update profile error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getZoomSignature = async (meetingNumber, role) => {
  try {
    const { data } = await axios.post("http://localhost:5001/api/auth", {
      meetingNumber,
      role,
    });
    return data;
  } catch (error) {
    console.error("Error fetching Zoom signature:", error);
    throw error;
  }
};
